import React from 'react';
import { iSettings } from './AppSettingsContext';

export interface iApiEndpoint {
    url: string;
    loaderMessage: string;
    expiry_mins: number;
    type: string;
    isFeatureLoader: boolean;
    removeCacheEndpoints: string[];
    refreshCacheEndpoints: string[];
    errorMessage: string;
}

let ApiEndpointsContext: React.Context<iApiEndpoint[]>;

export class ApiEndpointsGetter {
    public async getApiEndpoints(appSettings: iSettings): Promise<React.Context<iApiEndpoint[]>> {
        const endpointFiles = [
            'aol-endpoints.json',
            'app-endpoints.json',
            'cargo-temp-log-endpoints.json',
            'commodity-book-endpoints.json',
            'orca-web-endpoints.json',
            'powerbi-endpoints.json',
            'report-event-endpoints.json',
            'rotation-endpoints.json',
            'tank-cleaning-endpoints.json',
            'verification-endpoints.json',
            'stowage-endpoints.json',
        ];

        const fetchEndpoints = endpointFiles.map(async (file) => {
            const response = await fetch(`assets/endpoints/${file}?v=${appSettings.releaseId}`);
            return response.json();
        });

        const endpoints = await Promise.all(fetchEndpoints);
        const mergedEndpoints = endpoints.reduce((acc, endpoint) => ({ ...acc, ...endpoint }), {});

        ApiEndpointsContext = React.createContext(mergedEndpoints);
        return ApiEndpointsContext;
    }
}

const getApiEndpointsContext = () => ApiEndpointsContext;
export default getApiEndpointsContext;
